var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", [
    _c(
      "ul",
      {
        staticClass:
          "nav navbar bg-white justify-content-between align-items-start"
      },
      [
        _vm._m(0),
        _vm._v(" "),
        !_vm.isPaymentPage()
          ? _c("li", { staticClass: "w-info" }, [
              _c("div", { staticClass: "d-flex d-md-none flex-wrap" }, [
                _c("div", { staticClass: "col-6 d-flex flex-column p-2" }, [
                  _c("small", { staticClass: "info-label" }, [
                    _vm._v("Invited by")
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "info-subtext" }, [
                    _vm._v(_vm._s(_vm.invitedBy))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 d-flex flex-column p-2" }, [
                  _c("small", { staticClass: "info-label" }, [_vm._v("Meal")]),
                  _vm._v(" "),
                  _c("small", { staticClass: "info-subtext" }, [
                    _vm._v(_vm._s(_vm.meal))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 d-flex flex-column p-2" }, [
                  _c("small", { staticClass: "info-label" }, [
                    _vm._v("Meal Date")
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "info-subtext" }, [
                    _vm._v(_vm._s(_vm.mealDate))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 d-flex flex-column p-2" }, [
                  _c("small", { staticClass: "info-label" }, [
                    _vm._v("Delivery time:")
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "info-subtext" }, [
                    _vm._v(_vm._s(_vm.deliveryTime))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 d-flex flex-column p-2" }, [
                  _c("small", { staticClass: "info-label" }, [
                    _vm._v("Deadline to order")
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "info-subtext" }, [
                    _vm._v(_vm._s(_vm.deadline))
                  ])
                ]),
                _vm._v(" "),
                _vm.subsidy > 0
                  ? _c("div", { staticClass: "col-6 d-flex flex-column p-2" }, [
                      _c("small", { staticClass: "info-label" }, [
                        _vm._v("Subsidy")
                      ]),
                      _vm._v(" "),
                      _c("small", { staticClass: "info-subtext" }, [
                        _vm._v("$" + _vm._s(_vm.subsidy))
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row d-none d-md-flex" }, [
                _c(
                  "div",
                  { staticClass: "col d-flex flex-column border-right" },
                  [
                    _c("small", { staticClass: "info-label" }, [
                      _vm._v("Invited by")
                    ]),
                    _vm._v(" "),
                    _c("small", { staticClass: "info-subtext" }, [
                      _vm._v(_vm._s(_vm.invitedBy))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col d-flex flex-column border-right" },
                  [
                    _c("small", { staticClass: "info-label" }, [
                      _vm._v("Meal")
                    ]),
                    _vm._v(" "),
                    _c("small", { staticClass: "info-subtext" }, [
                      _vm._v(_vm._s(_vm.meal) + " ")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col d-flex flex-column border-right" },
                  [
                    _c("small", { staticClass: "info-label" }, [
                      _vm._v("Meal Date")
                    ]),
                    _vm._v(" "),
                    _c("small", { staticClass: "info-subtext" }, [
                      _vm._v(_vm._s(_vm.mealDate))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col d-flex flex-column border-right" },
                  [
                    _c("small", { staticClass: "info-label" }, [
                      _vm._v("Delivery time:")
                    ]),
                    _vm._v(" "),
                    _c("small", { staticClass: "info-subtext" }, [
                      _vm._v(_vm._s(_vm.deliveryTime))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col d-flex flex-column border-right" },
                  [
                    _c("small", { staticClass: "info-label" }, [
                      _vm._v("Deadline to order")
                    ]),
                    _vm._v(" "),
                    _c("small", { staticClass: "info-subtext" }, [
                      _vm._v(_vm._s(_vm.deadline))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.subsidy > 0
                  ? _c("div", { staticClass: "col d-flex flex-column" }, [
                      _c("small", { staticClass: "info-label" }, [
                        _vm._v("Subsidy")
                      ]),
                      _vm._v(" "),
                      _c("small", { staticClass: "info-subtext" }, [
                        _vm._v("$" + _vm._s(_vm.subsidy))
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "nav-item" }, [
      _c("a", { attrs: { href: "https://hungerhub.com/", id: "logo" } }, [
        _c("img", {
          staticClass: "logo d-sm-block mx-auto",
          attrs: {
            src: require("../assets/img/hh-logo-dark.png"),
            alt: "Uncatering",
            "text-align": "center",
            "data-retina": "true"
          }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46b4ae05", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46b4ae05","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuestHeader.vue
// module id = null
// module chunks = 